export const New = () => {
  return (
    <div className="new">
      <p className="new__title">Что нового</p>
      <p className="new__description">
        Обновлён раздел бонусов и акций: больше регулярных предложений для
        покера и казино.
      </p>
      <p className="new__description">
        В каталоге слотов добавлены фильтры по провайдеру и RTP.
      </p>
      <p className="new__description">
        Добавлено отображение ближайшего отделения, банкомата или терминала на
        карте.
      </p>
      <p className="new__description">
        Добавлена поддержка Face ID и Touch ID.
      </p>
      <p className="new__description">
        Исправлена проблема с push-уведомлениями на части устройств с Android
        10.
      </p>
      <p className="new__description">
        Исправлено отображение слишком мелкого текста в настройках для
        пользователей Android.
      </p>
    </div>
  );
};
